"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.generateCartToken = function () {
  return Math.random().toString(36).substr(2);
};

exports.getMappedIncludes = function (included) {
  var mappedIncludes = {};

  if (!included) {
    return mappedIncludes;
  }

  return included.reduce(function (accumulator, include) {
    accumulator[include.type] = accumulator[include.type] || {};
    accumulator[include.type][include.id] = include;
    return accumulator;
  }, mappedIncludes);
};

exports.getRelationshipFromMappedIncludes = function (resourceObject, field, mappedIncludes) {
  var relationship = resourceObject.relationships[field];

  if (!relationship) {
    return null;
  }

  if (!relationship.data) {
    return null;
  }

  if (Array.isArray(relationship.data)) {
    return relationship.data.map(function (identifier) {
      return mappedIncludes[identifier.type][identifier.id];
    });
  } else {
    return mappedIncludes[relationship.data.type][relationship.data.id];
  }
};